import React, { useId } from 'react';
import clsx from 'clsx';
import { suffixId, useControlledValue } from '../../utils';
import { useRadioListContext } from '../RadioList/RadioListContext';
import { emptyRadioValue } from '../RadioList/RadioListSymbol';
import { VisuallyHidden } from '../VisuallyHidden';
import { Box } from '../Box';
import './Radio.css';
export function Radio(props) {
    const { children, id: userId, className, role, prefix, postfix, label, complement, description, value, name: userName, checked: userChecked, defaultChecked, disabled, required, onChange, onFocus, onBlur, UNSAFE_elementType = 'label', inputRef, UNSAFE_labelRef, UNSAFE_contentClassName, UNSAFE_indicatorClassName, UNSAFE_indicatorContent, autoFocus, ...rest } = props;
    const { name: contextName, checkedValue, setCheckedValue, } = useRadioListContext();
    const name = userName !== null && userName !== void 0 ? userName : contextName;
    const normalizedCheckedValue = checkedValue === emptyRadioValue && defaultChecked ? value : checkedValue;
    const [checked, setChecked] = useControlledValue({
        value: userChecked !== null && userChecked !== void 0 ? userChecked : (typeof checkedValue !== 'undefined'
            ? String(normalizedCheckedValue) === String(value)
            : undefined),
        defaultValue: defaultChecked !== null && defaultChecked !== void 0 ? defaultChecked : false,
    });
    const uniqueId = useId();
    const id = userId !== null && userId !== void 0 ? userId : uniqueId;
    let labelProps;
    if (UNSAFE_elementType === 'label') {
        labelProps = {
            htmlFor: id,
        };
    }
    const labelId = suffixId(id, 'label');
    return (React.createElement(Box.Restricted, { elementType: UNSAFE_elementType, ...labelProps, ...rest, id: labelId, className: clsx('mollie-ui-radio', {
            'mollie-ui-radio--checked': checked,
        }, className), ref: UNSAFE_labelRef, "data-checked": checked, "data-disabled": disabled },
        React.createElement(VisuallyHidden, { elementType: "input", role: role, value: value, name: name, checked: checked, defaultChecked: typeof checked === 'undefined' ? defaultChecked : undefined, disabled: disabled, required: required, onChange: (e) => {
                setChecked(e.target.checked);
                setCheckedValue(e.target.value);
                if (onChange)
                    onChange(e);
            }, onFocus: onFocus, onBlur: onBlur, type: "radio", id: id, "aria-labelledby": labelId, ref: inputRef, autoFocus: autoFocus, "data-autofocus": autoFocus }),
        React.createElement("span", { className: clsx('mollie-ui-radio-indicator', UNSAFE_indicatorClassName) }, UNSAFE_indicatorContent),
        prefix && React.createElement("div", { className: "mollie-ui-radio-prefix" }, prefix),
        (label || children) && (React.createElement("div", { className: clsx('mollie-ui-radio-content', UNSAFE_contentClassName) },
            label,
            complement && (React.createElement(React.Fragment, null,
                label && ' ',
                React.createElement("span", { className: "mollie-ui-radio-complement" }, complement))),
            children,
            description && (React.createElement("div", { className: "mollie-ui-radio-description" }, description)))),
        postfix && React.createElement("div", { className: "mollie-ui-radio-postfix" }, postfix)));
}
//# sourceMappingURL=Radio.js.map